import { RootState } from "../../app";
import { createSelector } from "@reduxjs/toolkit";
import { ConfigMap } from "../../configMap";
import {
  selectConfigMapCategorizations,
  selectGroupBlockCategorizations,
} from "../../configMap/selectors/categorizationLinkSelectors";

type Props = {
  categorizationId: string | undefined;
};

const selectConfigMap = (state: RootState) => state.configMapReducer.configMap;

const selectCategorizationId = (_: RootState, props: Props) =>
  props.categorizationId;

const selectIsCategorizationInSideControls = createSelector(
  selectConfigMap,
  selectCategorizationId,
  (configMap: ConfigMap | undefined, categorizationId: string | undefined) => {
    if (!configMap || !categorizationId) {
      return undefined;
    }

    const configMapCategorizations = selectConfigMapCategorizations(configMap);
    const isInSideControls = configMapCategorizations.find(
      (cwc) => cwc.categorization.id === categorizationId,
    );
    if (isInSideControls) {
      return true;
    }

    const isInTableControls = configMap.groupBlocks?.some((gb) => {
      const groupBlockCategorizations = selectGroupBlockCategorizations(gb);
      return groupBlockCategorizations.some(
        (cwc) => cwc.categorization.id === categorizationId,
      );
    });
    if (isInTableControls) {
      return false;
    }

    return undefined;
  },
);

export default selectIsCategorizationInSideControls;
